import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { visuallyHidden } from '@mui/utils';
import { useState } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { Button, Grid, Stack, TextField as MuiTextField, } from '@mui/material';
import useAxiosPrivate from '../../hooks/use-axios-private';
import Empty from '../../components/Empty';
import { useTheme } from '@emotion/react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ModalBox from '../../components/ModalBox';
import { Formik, Form, Field } from "formik";
import { TextField } from 'formik-mui';
import * as Yup from 'yup';
import { alertMsg } from '../../utils/basicUtils';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { getRoleNameFromRoleId } from '../../utils/basicUtils';
import { ErrorMessage } from 'formik';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import Popup from '../../components/Popup';
import PasswordStrength from '../../components/PasswordStrength';

function Row({ row, getEmployeeList, onDelete, onEdit, onAction, handleRoleChange }) {
    return (
        <>
            <React.Fragment>
                <TableRow>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center", pl: { xs: 2, sm: 3, md: 4, lg: 6, xl: 8 } }}>
                            <Box>
                                <img style={{ width: "45px", borderRadius: "50%", height: "45px", objectFit: "cover", objectPosition: "top" }} src="https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="" />
                            </Box>
                            <Box sx={{ ml: 2 }}>
                                <Typography sx={{ fontSize: "15px", }}>{row.first_name}</Typography>
                            </Box>
                        </Box>
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 1 }}>
                        <Typography sx={{ fontSize: '15px' }}>{row.id}</Typography>
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 1, fontSize: "15px", }}>{row.email}</TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 1, fontSize: "15px", }}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Role</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={row.role_id}
                                label="Role"
                                onChange={handleRoleChange}
                            >
                                <MenuItem value={3}>QC</MenuItem>
                                <MenuItem value={4}>Editor</MenuItem>
                            </Select>
                        </FormControl>
                    </TableCell>
                    <TableCell align="center" sx={{ whiteSpace: "nowrap", p: 1, }}>
                        <Box sx={{ display: "flex", alignItems: 'center', gap: 1, justifyContent: "center", pl: { xs: 2, sm: 3, md: 4, lg: 6, xl: 8 } }}>
                            <Button startIcon={<ErrorOutlineIcon />} variant="text" color="primary" sx={{ minWidth: 130, textTransform: "capitalize", fontWeight: 400, fontSize: 14 }} onClick={onAction}>
                                {row.is_active ? "Deactivate" : "Activate"}
                            </Button>
                            <Button startIcon={<EditOutlinedIcon />} variant="text" color="primary" sx={{ textTransform: "capitalize", fontWeight: 400, fontSize: 14 }} onClick={onEdit}>
                                Edit
                            </Button>
                            <Button startIcon={<DeleteOutlineIcon />} variant="text" color="error" sx={{ textTransform: "capitalize", fontWeight: 400, fontSize: 14 }} onClick={onDelete}>
                                Delete
                            </Button>
                        </Box>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        </>

    );
}

const headCells = [
    {
        id: 'first_name',
        numeric: true,
        disablePadding: false,
        label: 'First Name',
    },
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: 'ID',
    },
    {
        id: 'email',
        numeric: true,
        disablePadding: false,
        label: 'Email',
    },
    {
        id: 'role',
        numeric: true,
        disablePadding: false,
        label: 'Role',
    },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Actions',
    },
];

const DEFAULT_ROWS_PER_PAGE = 5;

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } =
        props;

    const createSortHandler = (newOrderBy) => {

        onRequestSort(newOrderBy);
    };
    return (
        <TableHead>
            <TableRow sx={{ height: { xs: 65, xl: 70 } }}>
                {headCells.map((headCell, index) => (
                    <TableCell
                        key={index}
                        align='center'
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{ whiteSpace: "nowrap", px: 3 }}
                    >
                        {
                            headCell.id !== 'action'
                                ?
                                <TableSortLabel
                                    active={orderBy === headCell.id}
                                    direction={orderBy}
                                    onClick={() => createSortHandler(headCell.id)}
                                >
                                    {headCell.label}
                                    {orderBy === headCell.id && (
                                        <Box component="span" sx={visuallyHidden}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </Box>
                                    )
                                    }
                                </TableSortLabel>
                                :
                                headCell.label
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    //  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    // orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    // const [showFilter, setShowFilter] = useState(false)
    const { numSelected, onSearchChange, userRole } = props
    // const onFilterChange = (e) => {
    //     props.onFilterChange(e)
    //     setShowFilter(false)
    // }

    return (
        <>
            <Box sx={{ mt: 3, px: 2 }}>
                <Toolbar
                    sx={{
                        px: { xs: 0, sm: 1 },
                        ...(numSelected > 0 && {
                            bgcolor: (theme) =>
                                alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                        }),
                        alignItems: { xs: 'end', sm: 'center' }
                    }}
                >
                    {numSelected > 0 ? (
                        <Typography
                            sx={{ flex: '1 1 100%' }}
                            color="inherit"
                            variant="subtitle1"
                            component="div"
                        >
                            {numSelected} selected
                        </Typography>
                    ) : (
                        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'baseline', sm: 'center' }} justifyContent='space-between' sx={{ width: '100%', mt: { xs: 3, sm: 0 } }}>
                            <Typography
                                sx={{ flex: '1 1 100%', fontSize: { xs: 18, xl: 20 }, fontWeight: 500 }}
                                id="tableTitle"
                                component="div"
                            >
                                {/* EmployeeView */}
                                {userRole}
                            </Typography>
                            <Box sx={{ width: { xs: '100%', sm: 300 }, maxWidth: '100%', }}>
                                <MuiTextField fullWidth label="Search" variant="standard" size="small" type='search' onChange={onSearchChange} autoComplete='off' />
                            </Box>
                        </Stack>
                    )}

                    {numSelected > 0 ? (
                        <>
                            <Tooltip title="Delete">
                                <IconButton color='error'>
                                    <DeleteOutlineOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Duplicate">
                                <IconButton>
                                    <ContentCopyOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit">
                                <IconButton>
                                    <EditOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    ) : (
                        <>
                            {/* <Tooltip title="Filter list">
                                <IconButton sx={{backgroundColor:'#f3f3f3'}} onClick={(e) => {
                                    setShowFilter(prev => {
                                        return prev ? false : e.target
                                    })
                                }}>
                                    <FilterListIcon />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                open={showFilter}
                                anchorEl={showFilter}
                                onClose={() => setShowFilter(false)}
                            >
                                <MenuItem onClick={() => onFilterChange('ALL')}>All</MenuItem>
                                <MenuItem onClick={() => onFilterChange('7DAYS')}>Last 7 days</MenuItem>
                                <MenuItem onClick={() => onFilterChange('LST_MONTH')}>Last month</MenuItem>
                                <MenuItem onClick={() => onFilterChange('LST_3_MONTH')}>Last 3 months</MenuItem>
                            </Menu> */}
                        </>
                    )}
                </Toolbar>
            </Box>
        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    <Typography component={"div"}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const EmployeeView = ({ roleId }) => {
    const theme = useTheme()
    const [ascorder, setAscorder] = useState("desc")
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);
    const [paddingHeight, setPaddingHeight] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [count, setCount] = useState(0);
    const axios = useAxiosPrivate()
    const [orderByJobs, setOrderByJobs] = useState([])
    const initialEmployeeValues = {
        username: '',
        first_name: '',
        last_name: '',
        gender: '',
        dob: '',
        email: '',
        mobile_number: '',
        country_code: '',
        mobile_code: '',
        street: '',
        city: '',
        state: '',
        country: '',
        zipcode: '',
        headshot: '',
        password: '',
        confirm_password: '',
        employee_id: ''
    }
    const [employeeList, setEmployeeList] = useState([])
    const [open, setOpen] = useState(false)
    const [employeeOperation, setEmployeeOperation] = useState('Create')
    const [employeeValues, setEmployeeValues] = useState(initialEmployeeValues)
    const [showAlert, setShowAlert] = useState(false);
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [showActionPop, setShowActionPop] = useState(false)
    const [showRolePop, setShowRolePop] = useState(false)
    const [isActiveRow, setIsActiveRow] = useState({ is_active: 0 })
    const [role, setRole] = useState(null)

    const changeRole = async (e, row) => {
        try {
            if (role && row.id) {
                if (role !== row.role_id) {
                    const resp = await axios.put(`users/update_role/`, { role_id: role, user_id: row.id })
                    alertMsg(resp.data.message, 'success')
                    getEmployeeList()
                }
            } else {
                alertMsg("Hi Admin, There is error in role change, Please contact the support team", 'error')
            }
        }

        catch (error) {
            console.error(error)
        }
    }

    const deactiveEmployee = async (row) => {
        try {
            let resp = await axios.post('users/change_status/', {
                'user_id': row.id
            })
            setIsActiveRow(resp.data.data.is_active)
            getEmployeeList()

        }
        catch (error) {
            console.error(error)
        }
    }

    const getEmployeeList = async () => {
        try {
            const resp = await axios.get('users/list/', {
                params: {
                    limit: rowsPerPage, search: searchText, page: page + 1, role_id: roleId
                    , order_by: orderByJobs, order_by_type: ascorder
                }
            })
            setCount(resp.data.data.page_info.count)
            setEmployeeList(resp.data.data.users)
        } catch (error) {
            console.error(error)
        }
    }
    const deleteEmployee = async (id) => {
        try {
            let resp = await axios.delete(`users/delete/${id}`)
            alertMsg(resp.data.message, 'success')
            getEmployeeList()
        }
        catch (error) {
            console.error(error)
        }
    }
    useEffect(() => {
        getEmployeeList()
    }, [rowsPerPage, searchText, page, ascorder, orderByJobs]);


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            return;
        }
        setSelected([]);
    };
    const orderChange = (newOrderBy) => {
        if (newOrderBy === 'action') {
            return false
        }
        if (ascorder === "desc") {
            setAscorder("asc")
            setOrderByJobs(newOrderBy)
        }
        else {
            setAscorder("desc")
            setOrderByJobs(newOrderBy)
        }
    }


    const handleChangePage = useCallback(
        (event, newPage) => {
            setPage(newPage)
        },
        []
    );

    const handleChangeRowsPerPage = useCallback(
        (event) => {
            const updatedRowsPerPage = parseInt(event.target.value, 10);
            setRowsPerPage(updatedRowsPerPage);
            setPage(0);
            // There is no layout jump to handle on the first page.role
            setPaddingHeight(0);
        }, []
    );
    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ textAlign: "right" }}>
                <Button
                    variant='outlined'
                    onClick={() => {
                        setOpen(true)
                        setEmployeeOperation('Create')
                        setEmployeeValues(initialEmployeeValues)
                    }}
                >
                    Create {getRoleNameFromRoleId(roleId)} User
                </Button>
            </Box>
            <Paper sx={{ width: '100%', mb: 2, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>
                <Box>
                    <EnhancedTableToolbar
                        numSelected={selected.length}
                        onSearchChange={(e) => { setSearchText(e.target.value) }}
                        onFilterChange={e => { console.log(e) }}
                        userRole={getRoleNameFromRoleId(roleId)}
                    />
                    <ModalBox
                        open={open}
                        onClose={() => { setOpen(false) }}
                    >
                        <Box sx={{ maxHeight: "80vh", overflow: "auto", pr: 1 }} className="overflow-scroll">
                            <Box sx={{ mb: 5 }}>
                                <Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 20, xl: 22 } }} variant='h5'> {employeeOperation} {getRoleNameFromRoleId(roleId)} user</Typography>
                            </Box>
                            <Formik
                                initialValues={employeeValues}
                                validationSchema={
                                    Yup.object({
                                        first_name: Yup.string()
                                            .required('First name is required')
                                            .matches(/^[a-zA-Z\s]+$/, 'First name cannot contain special character and numbers')
                                            .min(3, 'First name must be at least 3 characters')
                                            .max(50, 'First name cannot exceed 50 characters'),
                                        last_name: Yup.string()
                                            .matches(/^[a-zA-Z\s]+$/, 'Last name cannot contain special character and numbers')
                                            .min(1, 'Last name minimum have 1 characters')
                                            .max(50, 'Last name cannot exceed 50 characters'),
                                        email: Yup.string().email()
                                            .required('Email is required')
                                            .email('Invalid email address'),
                                        username:
                                            Yup.string()
                                                .matches(/^[a-zA-Z0-9_]+$/, 'Invalid Username')
                                                .min(3, 'User name must be at least 3 numbers')
                                                .max(35, 'User name cannot exceed 35 characters'),
                                        password:
                                            employeeOperation === 'Create' &&
                                            Yup.string()
                                                .required("Password is required")
                                                // .matches(/^[^\s][ A-Za-z0-9_@./#&+-]+[^\s]$/, 'Password cannot contain whiteSpaces at the beginning and at the end')
                                                .min(8, "Must be at least 8 characters")
                                                .max(100, "Password cannot exceed 100 characters"),
                                        confirm_password:
                                            employeeOperation === 'Create' &&
                                            Yup.string()
                                                .required("Confirm Password is required")
                                                .oneOf([Yup.ref('password'), null], "Passwords doesn't match"),
                                        mobile_number: Yup.string()
                                            .required('Mobile Number is required')
                                            .min(10, 'Mobile number must be at least 10 numbers')
                                            .max(15, 'Mobile number cannot exceed 15 characters'),
                                        street: Yup.string()
                                            .nullable()
                                            .max(50, 'Street cannot exceed 50 characters'),
                                        city: Yup.string()
                                            .nullable()
                                            .matches(/^[a-zA-Z\s]+$/, 'This City cannot contain special character and numbers')
                                            .max(50, 'City cannot exceed 50 characters'),
                                        state: Yup.string()
                                            .nullable()
                                            .matches(/^[a-zA-Z\s]+$/, 'This State cannot contain special character and numbers')
                                            .max(50, 'State cannot exceed 50 characters'),
                                        zipcode: Yup.string()
                                            .nullable()
                                            .matches(/^[aA-zZ0-9\s]+$/, 'Invalid zipcode')
                                            .max(50, 'zipcode cannot exceed 50 characters'),
                                        employee_id: Yup.string()
                                            .required('Employee id is required')
                                            .min(3, 'Employee id  must be at least 3 numbers')
                                            .matches(/^[aA-zZ0-9\s]+$/, 'This Employee Id cannot contain special character'),
                                    })
                                }
                                onSubmit={async (values, { setSubmitting }) => {
                                    let resp = false
                                    const formData = { ...values }
                                    if (employeeOperation === 'Update') {
                                        try {
                                            resp = await axios.put('users/update/', { ...formData, user_id: values.id })
                                        } catch (e) {
                                            console.error("🚀 ~ file: EmployeeView.jsx:548 ~ onSubmit={ ~ e:", e)
                                            return
                                        }
                                    } else {
                                        try {
                                            resp = await axios.post('users/create_user/', { ...formData, role_id: roleId })
                                        } catch (e) {
                                            console.error("🚀 ~ file: EmployeeView.jsx:555 ~ onSubmit={ ~ e:", e)
                                            return
                                        }
                                    }
                                    alertMsg(resp.data.message, 'success')
                                    setSubmitting(false);
                                    getEmployeeList()
                                    setOpen(false)

                                }}
                            >
                                {
                                    ({ setFieldValue, values, setFieldTouched }) => (
                                        <Form>
                                            <Grid container spacing={{ xs: 3, }}>
                                                <Grid item xs={12} sm={6} >
                                                    <Box>
                                                        <Field
                                                            component={TextField}
                                                            name="first_name"
                                                            label="First Name *"
                                                            inputProps={{ maxLength: 35 }}
                                                            fullWidth
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6} >
                                                    <Box>
                                                        <Field
                                                            component={TextField}
                                                            name="last_name"
                                                            label="Last Name "
                                                            inputProps={{ maxLength: 35 }}
                                                            fullWidth
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6} >
                                                    <Box>
                                                        <Field
                                                            component={TextField}
                                                            name="username"
                                                            label="User Name"
                                                            inputProps={{ maxLength: 35 }}
                                                            fullWidth
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6} >
                                                    <Box>
                                                        <Field
                                                            component={TextField}
                                                            name="email"
                                                            label="Email *"
                                                            disabled={employeeOperation === 'Update'}
                                                            inputProps={{ maxLength: 235 }}
                                                            fullWidth
                                                        />
                                                    </Box>
                                                </Grid>
                                                {employeeOperation === 'Create' &&
                                                    <>
                                                        <Grid item xs={12} sm={6} >
                                                            <Box sx={{ position: "relative" }}>
                                                                <Field
                                                                    component={TextField}
                                                                    name="password"
                                                                    label="Password *"
                                                                    type={!showPassword ? "password" : "text"}
                                                                    fullWidth
                                                                    InputProps={{
                                                                        endAdornment:
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    onClick={() => { setShowPassword(prev => !prev) }}
                                                                                    edge="end"
                                                                                >
                                                                                    {!showPassword ? <VisibilityOff /> : <Visibility />}
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                    }}
                                                                />
                                                                <PasswordStrength password={values.password} sx={{ position: "absolute", bottom: { xs: -5, sm: -3, lg: -10 }, left: 35, display: "flex", alignItems: "center", gap: .5, justifyContent: "end", right: 2 }} ></PasswordStrength>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} >
                                                            <Box sx={{ position: "relative" }}>
                                                                <Field
                                                                    component={TextField}
                                                                    name="confirm_password"
                                                                    label="Confirm Password *"
                                                                    type={!showConfirmPassword ? "password" : "text"}
                                                                    fullWidth
                                                                    InputProps={{
                                                                        endAdornment:
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    onClick={() => { setShowConfirmPassword(prev => !prev) }}
                                                                                    edge="end"
                                                                                >
                                                                                    {!showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    </>
                                                }
                                                <Grid item xs={12} sm={6} >
                                                    <Box>
                                                        <Box sx={{ color: "#d32f2f", fontSize: "12px" }}>
                                                            <PhoneInput
                                                                className="phone-inp"
                                                                country={'us'}
                                                                onBlur={() => { setFieldTouched({ 'mobile_number': true }) }}
                                                                value={values.mobile_code + values.mobile_number}
                                                                onChange={(mobileNumber, mobileNumberObj) => {
                                                                    setFieldValue('mobile_number', mobileNumber.slice(mobileNumberObj.dialCode.length))
                                                                    setFieldValue('mobile_code', mobileNumberObj.dialCode)
                                                                    setFieldValue('country_code', mobileNumberObj.countryCode)
                                                                }}
                                                                fullWidth
                                                            />
                                                            <ErrorMessage name="mobile_number" />
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6} >
                                                    <Box>
                                                        <Field
                                                            component={TextField}
                                                            name="street"
                                                            label="Street"
                                                            inputProps={{ maxLength: 50 }}
                                                            fullWidth
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6} >
                                                    <Box>
                                                        <Field
                                                            component={TextField}
                                                            name="city"
                                                            label="City"
                                                            inputProps={{ maxLength: 50 }}
                                                            fullWidth
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6} >
                                                    <Box>
                                                        <Field
                                                            component={TextField}
                                                            name="state"
                                                            label="State"
                                                            inputProps={{ maxLength: 50 }}
                                                            fullWidth
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6} >
                                                    <Box>
                                                        <Field
                                                            component={TextField}
                                                            name="country"
                                                            label="Country"
                                                            fullWidth
                                                        />
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6} >
                                                    <Box>
                                                        <Field
                                                            component={TextField}
                                                            name="zipcode"
                                                            label="Postcode"
                                                            inputProps={{ maxLength: 50 }}
                                                            fullWidth
                                                        />
                                                    </Box>
                                                </Grid>

                                                <Grid item xs={12} sm={6} >
                                                    <Box>
                                                        <Field
                                                            component={TextField}
                                                            name="employee_id"
                                                            label="Employee Id *"
                                                            fullWidth
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            <Box sx={{ mt: 4, display: "flex", justifyContent: "end" }}>

                                                <Box>
                                                    <Button
                                                        variant="outlined"
                                                        size="large"
                                                        color="primary"
                                                        sx={{ mr: 2 }}
                                                        onClick={() => setOpen(false)}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Box>
                                                <Box>
                                                    <Button type="submit" size="large" variant="contained">Save</Button>
                                                </Box>
                                            </Box>
                                        </Form>
                                    )
                                }
                            </Formik>
                        </Box>
                    </ModalBox>
                    <Popup show={showActionPop} onSecondaryClick={() => setShowActionPop(false)} title={isActiveRow.is_active ? "Do you want to Deactivate" : "Do you want to Activate"} consent={false} variant='primary' primaryBtnTxt={"Ok"}
                        onPrimaryClick={async (e, loader) => {
                            try {
                                loader(true)
                                await deactiveEmployee(isActiveRow)
                                setShowActionPop(false)
                                loader(false)
                            }
                            catch (error) {
                                console.error(error)
                            }
                        }}
                    >
                        <Box sx={{ mt: 2, textAlign: "center" }}>
                            <Typography variant='span' sx={{ fontSize: "18px", fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Are you sure to {isActiveRow.is_active ? "deactivate" : "activate"} </Typography>
                            <Typography variant='span' sx={{ fontSize: "18px", fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>the user</Typography>
                            <Typography variant='span' sx={{ fontSize: "18px", fontWeight: "500", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> {employeeValues.first_name}. </Typography>
                        </Box>
                    </Popup>
                    <Popup show={showRolePop} onSecondaryClick={() => setShowRolePop(false)} title={role === 3 ? "Do you want change role to QC" : "Do you want change role to Editor"} consent={false} variant='primary' primaryBtnTxt={"Ok"}
                        onPrimaryClick={async (e, loader) => {
                            try {
                                loader(true)
                                await changeRole(e, isActiveRow)
                                setShowRolePop(false)
                                loader(false)
                            }
                            catch (error) {
                                console.error(error)
                            }
                        }}
                    >
                        <Box sx={{ mt: 2, textAlign: "center" }}>
                            <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Are you sure to change</Typography>
                            <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "500", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> {employeeValues.first_name}</Typography>
                            <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> as an {role === 3 ? "QC" : "editor"}</Typography>
                        </Box>
                    </Popup>
                    <Popup show={showAlert} onSecondaryClick={() => setShowAlert(false)} title={"Delete User?"} consent={true} variant='error' primaryBtnTxt={"Delete"}
                        onPrimaryClick={async (e, loader) => {
                            try {
                                loader(true)
                                await deleteEmployee(employeeValues.id)
                                setShowAlert(false)
                                loader(false)
                            }
                            catch (error) {
                                console.error(error)
                            }
                        }}
                    >
                        <Box sx={{ mt: 2, textAlign: "center" }}>
                            <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Are you sure you want to delete</Typography>
                            <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "500", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> {employeeValues.first_name} </Typography>
                            <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>User?</Typography>
                        </Box>
                        <Box sx={{ marginTop: "6px", textAlign: "center" }}>
                            <Typography sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>You can't undo this action.</Typography>
                        </Box>
                    </Popup>


                    {employeeList.length > 0
                        ?
                        <>
                            <TableContainer>
                                <Table
                                    sx={{ minWidth: 750 }}
                                    aria-labelledby="tableTitle"
                                    size={'medium'}
                                >
                                    <EnhancedTableHead
                                        numSelected={selected.length}
                                        //   order={order}
                                        //  orderBy={orderBy}
                                        onSelectAllClick={handleSelectAllClick}

                                        //  onRequestSort={orderChange}
                                        onRequestSort={(newOrderBy) => { orderChange(newOrderBy) }}
                                        rowCount={employeeList.length}
                                        orderBy={ascorder}
                                    />
                                    <TableBody>
                                        {employeeList
                                            && employeeList.map((row, index) => <Row
                                                key={row.id}
                                                row={row}
                                                getEmployeeList={getEmployeeList}
                                                onDelete={() => {
                                                    setShowAlert(true)
                                                    setEmployeeValues({ ...row })
                                                }}
                                                onAction={() => {
                                                    setIsActiveRow(row)
                                                    setShowActionPop(true)
                                                    setEmployeeValues({ ...row })
                                                }}
                                                handleRoleChange={(e) => {
                                                    setRole(e.target.value)
                                                    setIsActiveRow(row)
                                                    setShowRolePop(true)
                                                    setEmployeeValues({ ...row })
                                                }}
                                                onEdit={() => {
                                                    setOpen(true)
                                                    setEmployeeOperation('Update')
                                                    setEmployeeValues({ ...row })
                                                }}
                                            />
                                            )
                                        }
                                        {paddingHeight > 0 && (
                                            <TableRow
                                                style={{
                                                    height: paddingHeight,
                                                }}
                                            >
                                                <TableCell />
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={count}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </>
                        :
                        <Empty sx={{ border: "none", }} icon={<PersonOutlineOutlinedIcon sx={{ fontSize: 40, color: "grey" }} />} text="No users available" />
                    }
                </Box>
            </Paper>
        </Box>
    );

}

export default EmployeeView